<template>
  <vs-row vs-justify="center" id="customers-box">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
                    <vs-card vs-offset="9" vs-w="3">
      <vs-row>
                <vs-col>
                    <a href="https://app.liberrex.com/register" target="_blank">
                        <vs-button
                            icon="add"
                            color="primary"
                        >{{$t('Request.ApproveCustomer')}}</vs-button>
                    </a>
                </vs-col>
            </vs-row>
                    </vs-card>
      <vs-card>
        <div slot="header">

          <!-- DELETE PROMPT -->
            <div class="centerx con-exemple-prompt">
              <vs-prompt @accept="deleteCustomers(selected.id)" color="danger" @cancel="Closed" @close="Closed" :active.sync="activeDeletePrompt">
                <div class="con-exemple-prompt">
                  Are you sure to delete
                  {{selected.name}}
                  account ?
                </div>
              </vs-prompt> 
            </div>
            
            <!-- APPROVED/DISAPPROVED PROMPT -->

            <div class="centerx con-exemple-prompt">
              <vs-prompt @accept="updateApproval(selected.approved,selected.id)" color="success" @cancel="Canceled" @close="Canceled" :active.sync="activeApprovalPrompt">
                <div class="con-exemple-prompt">
                  {{$t('Company.Approved.Popup')[Number(!selected.approved)] +' '+  selected.name + ' ?'}}
                </div>
              </vs-prompt> 
            </div>

        </div>
        
        <vs-tabs :value="activeTab">

          <!-- ALL CUSTOMERS TAB -->
            
          <vs-tab :label="$t('Customer.Tabs.All')" icon="list_alt" id="all-tab">
            <vs-table
              :sst="true"
              v-model="selected"
              :total="totalItems"
              max-items="10"
              search
              :data="business_requests"
            >
              <template slot="thead">
                <vs-th sort-key="contactname" >#</vs-th>
                <vs-th sort-key="contactname" >{{$t('Customer.Table.FullName')}}</vs-th>
                <vs-th sort-key="joindate"  >{{$t('Customer.Email')}}</vs-th>
                <vs-th sort-key="phone" >{{$t('Customer.PhoneNumber')}}</vs-th>
                <vs-th sort-key="phone" >{{$t('Request.Country')}}</vs-th>
                <vs-th sort-key="phone" >{{$t('Request.RequestedTime')}}</vs-th>
                <vs-th>{{$t('Customer.Table.Approved')}}</vs-th>
                <vs-th>{{$t('Customer.Table.Options')}}</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].user.photo">
                    <div class="d-flex no-block align-items-center">
                      <div class>
                        <img :src="data[indextr].user.photo" width="50" class="" alt="user" v-if="data[indextr].user.photo"/>
                        <vs-avatar size="50px" icon="person" v-else></vs-avatar>
                      </div>
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].user.fullname">
                    <div class="d-flex no-block align-items-center">
                      <div class>
                        <h5 class="mb-0 font-16">{{ data[indextr].user.fullname }} </h5>
                        <span class="text-muted">{{ data[indextr].user.fullname }}</span>
                      </div>
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].email">
                    <div
                      class="d-flex align-items-center"
                    >{{ data[indextr].email }}</div>
                  </vs-td>

                  <vs-td :data="data[indextr].phone">
                    <div class="d-flex align-items-center">
                      <i class="mdi mdi-phone-classic mr-2 display-8"></i>
                      <span class="text-muted">{{data[indextr].phone}}</span>
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].user.country">
                    <div
                      class="d-flex align-items-center"
                    >{{ data[indextr].user.country  }}</div>
                  </vs-td>

                  <vs-td :data="data[indextr].created_at">
                    <div
                      class="d-flex align-items-center"
                    >{{ data[indextr].created_at }}</div>
                  </vs-td>

                  <vs-td :data="data[indextr].approved">
                     <vs-switch color="success" v-model="data[indextr].approved" @input="approvedPromptMember(data[indextr].approved,data[indextr].id,data[indextr].user.fullname)"> <!--updateApproval(data[indextr].approved,data[indextr].id) -->
                    </vs-switch>
                  </vs-td>

                  <vs-td>
                    <div class="btn-alignment">
                      <vs-button
                        radius
                        color="primary"
                        type="border"
                        icon="email"
                      ></vs-button>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vs-tab>

          <!-- APPROVED CUSTOMERS TAB -->

          <vs-tab :label="$t('Customer.Tabs.Approved')" icon="check_box" id="approved-tab">
            <vs-table
              :sst="true"
              v-model="selected"
              :total="totalItems"
              max-items="10"
              search
              :data="approved_business_requests"
            >
              <template slot="thead">
                <vs-th sort-key="contactname" >#</vs-th>
                <vs-th sort-key="contactname" >{{$t('Customer.Table.FullName')}}</vs-th>
                <vs-th sort-key="joindate"  >{{$t('Customer.Email')}}</vs-th>
                <vs-th sort-key="phone" >{{$t('Customer.PhoneNumber')}}</vs-th>
                <vs-th sort-key="phone" >{{$t('Request.Country')}}</vs-th>
                <vs-th sort-key="phone" >{{$t('Request.RequestedTime')}}</vs-th>
                <vs-th>{{$t('Customer.Table.Approved')}}</vs-th>
                <vs-th>{{$t('Customer.Table.Options')}}</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].user.photo">
                    <div class="d-flex no-block align-items-center">
                      <div class>
                        <img :src="data[indextr].user.photo" width="50" class="" alt="user" v-if="data[indextr].user.photo"/>
                        <vs-avatar size="50px" icon="person" v-else></vs-avatar>
                      </div>
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].user.fullname">
                    <div class="d-flex no-block align-items-center">
                      <div class>
                        <h5 class="mb-0 font-16">{{ data[indextr].user.fullname }} </h5>
                        <span class="text-muted">{{ data[indextr].user.fullname }}</span>
                      </div>
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].email">
                    <div
                      class="d-flex align-items-center"
                    >{{ data[indextr].email }}</div>
                  </vs-td>

                  <vs-td :data="data[indextr].phone">
                    <div class="d-flex align-items-center">
                      <i class="mdi mdi-phone-classic mr-2 display-8"></i>
                      <span class="text-muted">{{data[indextr].phone}}</span>
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].user.country">
                    <div
                      class="d-flex align-items-center"
                    >{{ data[indextr].user.country  }}</div>
                  </vs-td>

                  <vs-td :data="data[indextr].created_at">
                    <div
                      class="d-flex align-items-center"
                    >{{ data[indextr].created_at }}</div>
                  </vs-td>

                  <vs-td :data="data[indextr].approved">
                     <vs-switch color="success" v-model="data[indextr].approved" @input="approvedPromptMember(data[indextr].approved,data[indextr].id, data[indextr].user.fullname)"> <!--updateApproval(data[indextr].approved,data[indextr].id) -->
                    </vs-switch>
                  </vs-td>

                  <vs-td>
                    <div class="btn-alignment">
                      <vs-button
                        radius
                        color="primary"
                        type="border"
                        icon="email"
                      ></vs-button>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          <vs-pagination @change="handleChangeApprovedPage" :total="totalApprovedPages"  v-model="currentApprovedPage"></vs-pagination>
          </vs-tab>

          <!-- DISAPPROVED CUSTOMERS TAB -->

          <vs-tab :label="$t('Customer.Tabs.Disapproved')" icon="cancel" id="disapproved-tab">
            <vs-table
              :sst="true"
              v-model="selected"
              :total="totalItems"
              max-items="10"
              search
              :data="disapproved_business_requests"
            >
              <template slot="thead">
                <vs-th sort-key="contactname" >#</vs-th>
                <vs-th sort-key="contactname" >{{$t('Customer.Table.FullName')}}</vs-th>
                <vs-th sort-key="joindate"  >{{$t('Customer.Email')}}</vs-th>
                <vs-th sort-key="phone" >{{$t('Customer.PhoneNumber')}}</vs-th>
                <vs-th sort-key="phone" >{{$t('Request.Country')}}</vs-th>
                <vs-th sort-key="phone" >{{$t('Request.RequestedTime')}}</vs-th>
                <vs-th>{{$t('Customer.Table.Approved')}}</vs-th>
                <vs-th>{{$t('Customer.Table.Options')}}</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].user.photo">
                    <div class="d-flex no-block align-items-center">
                      <div class>
                        <img :src="data[indextr].user.photo" width="50" class="" alt="user" v-if="data[indextr].user.photo"/>
                        <vs-avatar size="50px" icon="person" v-else></vs-avatar>
                      </div>
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].user.fullname">
                    <div class="d-flex no-block align-items-center">
                      <div class>
                        <h5 class="mb-0 font-16">{{ data[indextr].user.fullname }} </h5>
                        <span class="text-muted">{{ data[indextr].user.fullname }}</span>
                      </div>
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].email">
                    <div
                      class="d-flex align-items-center"
                    >{{ data[indextr].email }}</div>
                  </vs-td>

                  <vs-td :data="data[indextr].phone">
                    <div class="d-flex align-items-center">
                      <i class="mdi mdi-phone-classic mr-2 display-8"></i>
                      <span class="text-muted">{{data[indextr].phone}}</span>
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].user.country">
                    <div
                      class="d-flex align-items-center"
                    >{{ data[indextr].user.country  }}</div>
                  </vs-td>

                  <vs-td :data="data[indextr].created_at">
                    <div
                      class="d-flex align-items-center"
                    >{{ data[indextr].created_at }}</div>
                  </vs-td>

                  <vs-td :data="data[indextr].approved">
                     <vs-switch color="success" v-model="data[indextr].approved" @input="approvedPromptMember(data[indextr].approved,data[indextr].id, data[indextr].user.fullname)"> <!--updateApproval(data[indextr].approved,data[indextr].id) -->
                    </vs-switch>
                  </vs-td>

                  <vs-td>
                    <div class="btn-alignment">
                      <vs-button
                        radius
                        color="primary"
                        type="border"
                        icon="delete"
                      ></vs-button>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vs-tab>
        </vs-tabs>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import { businessService } from "../../_services";
import router from "../../_helpers/router";
// moment
import moment from 'moment'

export default {
  name: "Customers",
  data: () => ({
    title: "Customers",
    activePrompt: false,
    activeDeletePrompt:false,
    activeUpdatePrompt: false,
    activeBookPrompt: false,
    activeUploadPrompt: false,
    activeApprovalPrompt: false,
    businesses: [],
    approvedBusinesses : [],
    disapprovedBusinesses : [],
    selected: {},
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
    totalApprovedPages: 0,
    currentApprovedPage: 1,
    totalDisapprovedPages: 0,
    currentDisapprovedPage: 1,
    maxItems: 0,
    importModal: {
      file: null
    },
    steps: [
      {
        target: "#add-customer-form", // We're using document.querySelector() under the hood
        header: {
          title: "Get Started"
        },
        params: {
          placement: "right-start" // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        }
      },
      {
        target: "#edit-customer-button",
        params: {
          placement: "auto" // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        }
      }
    ],
    errors: {
      firstName: false,
      lastName: false,
      email: false,
      phoneNumber: false,
      libID: false,
      selected: {
        firstName: false,
        lastName: false,
        email: false,
        phoneNumber: false,
        libID: false
      }
    },
    fname: "",
    lname: "",
    phone_number: "",
    address: "",
    email: "",
    notes: "",
    internalId: "",
    dateOfBirth: "",
    searchKeyword: "",
    business_requests: [],
    approved_business_requests: [],
    disapproved_business_requests: []
  }),
  methods: {
    Closed() {
      this.$vs.notify({
        color: "danger",
        title: "Delete Cancel",
        text: "Cancelling!"
      });
    },
    Canceled(){
      this.selected.approved = !this.selected.approved;
      this.$vs.notify({
        color: "danger",
        title: "Approval Cancel",
        text: "Cancelling!"
      });
    },
    showCustomer(item){
        this.$router.push('/customers/show/'+item);
    },
    updateCustomer(item) {
      this.$router.push("/customers/" + item + "/update");
    },
    updateApproval(approved,id){
        this.showLoading();
        businessService.UpdateBusinessRequestApproval(id).then(data =>{
          this.notify(
              this.$t("Toasts.Successful"),
              this.$t("Request.ToastSuccessMessage"),
              "success"
            );
        }).catch(
          function() {
            this.notify(
              this.$t("Toasts.Error"),
              this.$t("Request.ToastFailMessage"),
              "danger"
            );
          }.bind(this)
        )
        .finally(function() {
            this.hideLoading();
        }.bind(this)
        );
    },
    deleteCustomers(id) {
       let self = this;
      businessService
        .deleteBusiness(id)
        .then(function(data) {
      self.$vs.notify({title: 'succes delete',text: 'account successfully deleted', position: 
         'bottom-right', type: 'success' ,color:'green' });
         router.go();
        })
        .bind(this);
         
      this.activeDeletePrompt = false;
      this.selected = null;
     // this.$router.push('/settings/team');S
  
    },
    approvedPromptMember(approved,item, name){
      this.selected.id = item;
      this.selected.approved = approved;
      this.selected.name = name;
      this.activeApprovalPrompt = true;
    },
    deletePromptMember(item) {
      this.selected.id = item;
      this.activeDeletePrompt = true;
    },
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text
      });
    },
    showLoading() {
      this.$vs.loading({
        container: "#customers-box",
        scale: 0.6
      });
    },
    hideLoading() {
     this.$vs.loading.close("#customers-box > .con-vs-loading");
    },
 
  },
  computed: {
  },
  components: {},

  mounted() {
    this.showLoading();
    businessService.getAllRequests().then(function (data) {
        var i=0;
        this.business_requests = data.business_requests.map(obj => {
            if(obj.approved==1){
                this.approved_business_requests[i]= obj;
            }else{
                this.disapproved_business_requests[i]= obj;
            }
            i++;
            obj.created_at= moment(obj.created_at).format('MM/DD/YYYY hh:mm:ss');
            return obj;
        });
    }.bind(this))
    .finally(() => {
        this.hideLoading();
        console.log(this.business_requests);
        console.log(this.approved_business_requests);
        console.log(this.disapproved_business_requests);
    });
  } 
};
</script>
